'use client'

import { useTranslations } from 'next-intl'

import S from './HeroTextBlock.module.scss'

const HeroTextBlock = () => {
  const t = useTranslations('hero')

  return (
    <div className={S.textBlock}>
      <div className={S.title}>
        {t('title.line1') && <p className={S.titleLine}>{t('title.line1')}</p>}
        {t('title.line2') && <p className={S.titleLine}>{t('title.line2')}</p>}
        {t('title.line3') && (
          <p className={S.titleLineSecondary}>{t('title.line3')}</p>
        )}
      </div>
      <p className={S.subtitle}>{t('subtitle')}</p>
    </div>
  )
}

export default HeroTextBlock
